// ===========================================
// File: lib/landing/constants.ts
// ===========================================

export const COMPANY = {
  // Brand
  name: "THE CONCLUSION DAILY",
  shortName: "TCD",
  legalName: "THE CONCLUSION DAILY",

  tagline: "Hope & Faith ",

  // Hero
  heroTitle: "India's Competitive Learning Ecosystem",

  heroDescription:
    "The Conclusion Daily is building India's next-generation examination and competitive learning platform where students practice, compete, improve their skills, earn rewards, and institutions conduct secure online examinations.",

  // Buttons
  primaryButton: "Start Learning",
  secondaryButton: "Request Institute Demo",

  // URLs
  website: "https://theconclusiondaily.com",
  examPortal: "https://exam.theconclusiondaily.com",

  loginUrl: "https://exam.theconclusiondaily.com/login",
  signupUrl: "https://exam.theconclusiondaily.com/signup",

  // Contact
  email: "support@theconclusiondaily.com",

  // Brand Colors
  colors: {
    primary: "#243B6B",
    secondary: "#36558F",
    gold: "#D4AF37",
    background: "#F8F9FB",
    dark: "#1F2937",
  },

  // Statistics
  stats: [
    {
      value: "1000+",
      label: "Practice Questions",
    },
    {
      value: "Live",
      label: "Competitive Exams",
    },
    {
      value: "AI",
      label: "Exam Security",
    },
    {
      value: "Nationwide",
      label: "Learning Platform",
    },
  ],

  // Social
  social: {
    youtube: "#",
    linkedin: "#",
    instagram: "#",
    facebook: "#",
  },

  // Footer
  copyright:
    "© 2026 THE CONCLUSION DAILY. All Rights Reserved.",
};

export default COMPANY;